import {
  // accessoryInArray,
  findAccessoryInfo as defFindAccessoryInfo,
} from '../index';
import {
  instantiateAccessory as defInstantiateAccessory,
  getProductInfoBySlotName,
} from '../defaults';
import {
  getProductsBySlotNameAndId,
  getObjectAtSystemDefinitionSlot,
  getComponentType,
} from '../../project-definition-data-access';

function getTargetSlot(slotName, systemDefinition, systemProducts) { // eslint-disable-line
  // TODO: return something else if not a chimney of a kettle
  return 'kettle';
}

export function getChimneyDiameter(slotName, systemDefinition, systemProducts, create = false) { // eslint-disable-line
  if (!systemDefinition) {
    return null;
  }
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const slotvalue = systemDefinition.attributes.slots[targetSlotName];
  if (!slotvalue) {
    return null;
  }
  const { chimney } = slotvalue;

  if (!chimney) {
    return null;
  }
  let diameter = chimney.diameter || chimney.diameters;
  if (diameter || !create) {
    return diameter;
  }

  diameter = {};
  chimney.diameters = diameter;

  return diameter;
}

export function getChimneyData(slotName, systemDefinition, systemProducts, create) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const type = getComponentType(targetSlotName);
  const slot = type ? type.slot : null;

  const kettle = systemDefinition.attributes.slots[slot];
  if (!kettle) {
    return null;
  }
  let { chimney } = kettle;
  if (chimney || !create) {
    return chimney;
  }
  chimney = {};
  kettle.chimney = chimney;

  return chimney;
}

export function getChimneyDiameterValue(slotName, systemDefinition, systemProducts) {
  const diameter = getChimneyDiameter(slotName, systemDefinition, systemProducts);
  if (!diameter) {
    return null;
  }

  return diameter.diameter;
}

function updateChimneyAccessories(slotName, systemDefinition, systemProducts) {
  // Remove all incompatible accessories
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);

  const type = getComponentType(targetSlotName);
  const slot = type ? type.slot : null;

  const kettle = systemDefinition.attributes.slots[slot];

  if (!kettle) {
    return;
  }
  const { chimney } = kettle;
  if (!chimney) {
    return;
  }
  const { options } = chimney;

  if (!options) {
    return;
  }

  const numOptions = options.length;

  for (let i = numOptions - 1; i >= 0; i -= 1) {
    const option = options[i];
    const accessory = defFindAccessoryInfo(option, slotName, systemDefinition, systemProducts);

    if (!accessory) {
      options.splice(i, 1);
    }
  }
}

function findDiameterAdapterAccessoryId(slotName, systemDefinition, systemProducts, diameterParam) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const target = systemDefinition.attributes.slots[targetSlotName];

  const diameter = diameterParam || getChimneyDiameter(slotName, systemDefinition, systemProducts, true);
  if (!diameter) {
    return null;
  }

  const selectedDiameter = diameter.diameter;

  let adapterId = null;
  const exhaustLayout = target.chimney.exhaust_layout;
  const prod = getProductInfoBySlotName(targetSlotName, systemDefinition, systemProducts);
  const { chimneys } = prod;
  const numChimneys = chimneys ? chimneys.length : 0;
  for (let i = 0; i < numChimneys; i += 1) {
    const chimney = chimneys[i];
    if (chimney) {
      const { is_adapter, configurations, id: chimneyId } = chimney;
      const chimneyDiameter = chimney.diameter || chimney.diameters;
      let validDiameter = false;

      const validConfiguration = configurations ? configurations.includes(exhaustLayout) : false;

      if (Array.isArray(chimneyDiameter)) {
        validDiameter = chimneyDiameter.includes(selectedDiameter);
      } else if (typeof (chimneyDiameter) === 'string') {
        validDiameter = selectedDiameter === chimneyDiameter;
      }

      if (typeof (chimneyId) !== 'undefined' && is_adapter && validConfiguration && validDiameter) {
        adapterId = chimneyId;
      }
    }
  }
  return adapterId;
}

export function getChimneyLayout(slotName, systemDefinition) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition);
  const kettleDef = getObjectAtSystemDefinitionSlot(targetSlotName, systemDefinition);
  if (!kettleDef) {
    return null;
  }
  const { chimney } = kettleDef;
  if (!chimney) {
    return null;
  }
  return chimney.exhaust_layout;
}

function updateChimneyDiameter(slotName, systemDefinition, systemProducts) {
  // If the current diameter doesn't match the current exhaust layout,
  // change it to the first matching diameter

  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const target = systemDefinition.attributes.slots[targetSlotName];

  const currentChimneyLayout = getChimneyLayout(slotName, systemDefinition, systemProducts);
  const currentDiameter = getChimneyDiameter(slotName, systemDefinition, systemProducts);
  const currentDiameterValue = currentDiameter ? currentDiameter.diameter : null;
  let product = getProductsBySlotNameAndId(targetSlotName, target.id, systemProducts);
  if ((product instanceof Array) || (Array.isArray && Array.isArray(product))) {
    product = product[0];
  }
  const productDiameters = product ? product.diameters : null;
  const numProductDiameters = productDiameters ? productDiameters.length : 0;

  let fallbackDiameter = null;

  for (let i = 0; i < numProductDiameters; i += 1) {
    const diameter = productDiameters[i];
    const diameterName = diameter ? diameter.diameter : null;
    const diameterConfigs = diameter ? diameter.configurations : null;

    const isCurrentDiameter = diameterName === currentDiameterValue;
    const validDiameter = diameterConfigs ? diameterConfigs.includes(currentChimneyLayout) : false;

    if (validDiameter) {
      if (isCurrentDiameter) {
        return;
      }
      fallbackDiameter = diameter;
    }
  }
  if (fallbackDiameter && currentDiameter) {
    currentDiameter.main = fallbackDiameter.main;
    currentDiameter.diameter = fallbackDiameter.diameter;
    currentDiameter.adapter = findDiameterAdapterAccessoryId(slotName, systemDefinition, systemProducts, currentDiameter);
  }
}

function updateChimneyDiameterAndAccessories(slotName, systemDefinition, systemProducts) {
  // If the current diameter is not compatible with the current layout, change it to the first matching diameter
  updateChimneyDiameter(slotName, systemDefinition, systemProducts);

  // Remove incompatible accessories
  updateChimneyAccessories(slotName, systemDefinition, systemProducts);
}

export function setChimneyLayout(layout, slotName, systemDefinition, systemProducts) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const kettleDef = getObjectAtSystemDefinitionSlot(targetSlotName, systemDefinition);
  if (!kettleDef) {
    return;
  }
  const { chimney } = kettleDef;
  if (!chimney) {
    return;
  }
  chimney.exhaust_layout = layout;

  updateChimneyDiameterAndAccessories(slotName, systemDefinition, systemProducts);
}

export function setChimneyDiameter(diameterParam, slotName, systemDefinition, systemProducts) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const kettle = systemDefinition.attributes.slots[targetSlotName];

  const diameter = getChimneyDiameter(slotName, systemDefinition, systemProducts, true);
  if (!diameter) {
    return;
  }

  const diameterData = diameterParam.data;
  const selectedDiameter = diameterData.diameter;

  diameter.main = diameterData.main;
  diameter.diameter = selectedDiameter;

  if (!kettle.chimney.exhaust_layout && kettle.property) {
    kettle.chimney.exhaust_layout = kettle.property;
    kettle.property = null;
  }

  // Usually this is null because diameter.main === true
  const adapterId = findDiameterAdapterAccessoryId(slotName, systemDefinition, systemProducts);
  diameter.adapter = adapterId;
  updateChimneyAccessories(slotName, systemDefinition, systemProducts);
}

function enableChimneyInSystemDefinition(flag, systemDefinition) {
  if (!systemDefinition) {
    return false;
  }
  const { attributes } = systemDefinition;
  if (!attributes) {
    return false;
  }
  if (attributes.has_chimney !== flag) {
    attributes.has_chimney = flag;
    return true;
  }
  return false;
}

export function getSystemObjectAccessories(slotName, systemDefinition, systemProducts, productData, onlyOptionalAccessories) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const kettleDef = getObjectAtSystemDefinitionSlot(targetSlotName, systemDefinition);
  const kettleId = kettleDef ? kettleDef.id : null;
  const kettleResult = getProductsBySlotNameAndId(targetSlotName, kettleId, systemProducts);
  const kettle = Array.isArray(kettleResult) ? kettleResult[0] : kettleResult;
  let chimneyOptions = null;

  if (onlyOptionalAccessories) {
    chimneyOptions = kettle ? kettle.optional_chimneys || kettle.chimney_collections : null;
  } else {
    chimneyOptions = kettle ? kettle.chimneys : null;
  }
  if (!chimneyOptions) {
    return null;
  }
  const exhaustProp = getChimneyLayout(slotName, systemDefinition, systemProducts);
  const diameterValue = getChimneyDiameterValue(slotName, systemDefinition, systemProducts);

  if (!exhaustProp) {
    return null;
  }

  return chimneyOptions.filter((chimneyOption) => {
    const { configuration, configurations } = chimneyOption;
    const diam = chimneyOption.diameter || chimneyOption.diameters;
    const cfg = configuration || configurations;
    const cfgOk = !cfg || cfg.indexOf(exhaustProp) >= 0;
    const diamOk = !diam || diameterValue === diam;

    return cfgOk && diamOk;
  });
}


export function getSystemObjectPropertyValue(slotName, systemDefinition, systemProducts) { // eslint-disable-line
  return getChimneyLayout(slotName, systemDefinition, systemProducts);
  /*
  const data = getObjectAtSystemDefinitionSlot('kettle', systemDefinition);
  if (!data) {
    return null;
  }
  const { chimney } = data;
  if (!chimney) {
    return null;
  }
  return chimney.exhaust_layout;
  */
}

export function setSystemObjectPropertyValue(slotName, value, systemDefinition, systemProducts) { // eslint-disable-line
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const kettleData = getObjectAtSystemDefinitionSlot(targetSlotName, systemDefinition);
  if (!kettleData) {
    return;
  }
  kettleData.chimney = kettleData.chimney || {};
  kettleData.chimney.exhaust_layout = value;
  setChimneyLayout(value, slotName, systemDefinition, systemProducts);

  // Remove diameter if not compatible with system definition
  /*
  const accessories = kettleData.options;
  const numAccessories = accessories ? accessories.length : 0;
  // Remove all accessories incompatible with this exhaust layout
  if (numAccessories > 0) {
    const exhaustAccessories = getSystemObjectAccessories(slotName, systemDefinition, systemProducts, false);
    const exhaustAccessoriesOptional = getSystemObjectAccessories(slotName, systemDefinition, systemProducts, true);
    for (let i = numAccessories - 1; i >= 0; i -= 1) {
      const accessory = accessories[i];
      const accessoryId = accessory.id;
      if (accessory && accessory.set === 'chimney') {
        if (
          accessoryInArray(accessoryId, exhaustAccessories, slotName) ||
          exhaustAccessoriesOptional(accessoryId, exhaustAccessories, slotName)
        ) {
          accessories.splice(i, 1);
        }
      }
    }
  }
  */
}

export function getSystemObjectProperties(slotName, systemDefinition, systemProducts) {
  if (!slotName || !systemDefinition || !systemProducts) {
    // #if DEBUG
    console.warn('getSystemObjectProperties - Invalid parameters:', { slotName, systemDefinition, systemProducts });
    // #endif
    return null;
  }

  // Some unusual situations
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const kettleDef = systemDefinition.attributes.slots[targetSlotName];
  const kettleID = kettleDef ? kettleDef.id : null;

  const kettleResult = getProductsBySlotNameAndId(targetSlotName, kettleID, systemProducts);
  let kettle = kettleResult;
  if (Array.isArray(kettleResult)) {
    kettle = kettleResult[0];
  }

  return kettle ? kettle.exhaust_layouts : null;
}

export function findOptionIndex(option, slotName, systemDefinition, systemProducts) { // eslint-disable-line
  if (!option) {
    return -1;
  }
  const currentOptionId = `${option.id}`;

  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const kettleData = getObjectAtSystemDefinitionSlot(targetSlotName, systemDefinition);
  if (kettleData) {
    const chimneyData = getChimneyData(slotName, systemDefinition, systemProducts, false);
    if (!chimneyData) {
      return -1;
    }
    const { options } = chimneyData;
    const numOptions = options ? options.length : 0;
    for (let i = 0; i < numOptions; i += 1) {
      const opt = options[i];
      const optionId = `${opt ? opt.id : null}`;
      if (optionId === currentOptionId) {
        return i;
      }
    }
  }
  return -1;
}

export function canExcludeFromQuote(slotName, systemDefinition, systemProducts) { // eslint-disable-line
  return false;
}

export function instantiateAccessory(accessory, slotName, systemDefinition, systemProducts) {
  const result = defInstantiateAccessory(accessory, slotName, systemDefinition, systemProducts);
  if (!result) {
    return null;
  }
  result.set = 'chimney';
  return result;
}

export function addAccessory(slotName, accessory, systemDefinition, systemProducts) { // eslint-disable-line
  if (!slotName || !accessory || !systemDefinition || !systemDefinition.attributes) {
    return;
  }
  const { slots } = systemDefinition.attributes;
  if (!slots) {
    return;
  }
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const object = slots[targetSlotName];
  if (!object) {
    return;
  }
  const chimney = getChimneyData(slotName, systemDefinition, systemProducts, true);
  if (!chimney) {
    return;
  }
  const { options } = chimney;
  if (!options) {
    return;
  }
  const accessoryID = accessory.id;

  const numOptions = options.length;
  for (let i = 0; i < numOptions; i += 1) {
    const opt = options[i];
    if (opt && opt.id === accessoryID) {
      // Already added
      return;
    }
  }
  const resultAccessory = instantiateAccessory(accessory, slotName, systemDefinition, systemProducts);
  options.push(resultAccessory);
}

export function removeAccessory(slotName, accessory, systemDefinition, systemProducts) {
  if (!slotName || !accessory || !systemDefinition || !systemDefinition.attributes) {
    return;
  }
  const { slots } = systemDefinition.attributes;
  if (!slots) {
    return;
  }
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const object = slots[targetSlotName];
  if (!object) {
    return;
  }
  const chimney = getChimneyData(slotName, systemDefinition, systemProducts, true);
  if (!chimney) {
    return;
  }
  const { options } = chimney;
  if (!options) {
    return;
  }
  const accessoryID = accessory.id;

  const numOptions = options.length;
  for (let i = numOptions - 1; i >= 0; i -= 1) {
    const opt = options[i];
    if (opt && opt.id === accessoryID) {
      options.splice(i, 1);
    }
  }
}

// /////////////////////////////////////////////////////////////////////////////
//
// Other product properties
//
// /////////////////////////////////////////////////////////////////////////////
export function getProductName(
  slotName,
  systemDefinition,
  systemProducts,
  productData,
  intl, // eslint-disable-line
) {
  const messages = intl ? intl.messages : null;
  let result = null;
  if (messages) {
    result = messages['configurator.chimneyTitle'];
  }
  if (result) {
    if (result.includes('{layout}')) {
      const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);

      const layout = getChimneyLayout(targetSlotName, systemDefinition, systemProducts);
      // const data = systemDefinition.attributes.slots[targetSlotName];
      result = result.replace('{layout}', layout || '' : '');
    }
  }
  return result;
}

export function canRemoveProductFromSystemDefinition(slotName, systemDefinition, systemProducts, productInfo) { // eslint-disable-line
  if (!systemDefinition) {
    return false;
  }
  const { attributes } = systemDefinition;
  if (!attributes) {
    return false;
  }
  return attributes.has_chimney;
}

export function canAddAnyProductToSystemDefinition(slotName, systemDefinition, systemProducts, productInfo) { // eslint-disable-line
  return !canRemoveProductFromSystemDefinition(slotName, systemDefinition, systemProducts, productInfo);
}

function findBestExhaustLayout(exhaustLayouts) {
  const num = exhaustLayouts ? exhaustLayouts.length : 0;
  if (!num) {
    return null;
  }
  let res = null;
  for (let i = 0; i < num; i += 1) {
    const layout = exhaustLayouts[i];
    if (layout && (!res || layout === 'C33')) {
      res = layout;
    }
  }
  return res;
}

function findBestDiameter(diameters) {
  const num = diameters ? diameters.length : 0;
  if (!num) {
    return null;
  }
  let res = null;
  for (let i = 0; i < num; i += 1) {
    const diameter = diameters[i];
    if (diameter && (!res || diameter.main)) {
      res = diameter;
    }
  }

  return res;
}

function instantiateChimney(slotName, systemDefinition, systemProducts, productData) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  let product = productData;

  if (!product) {
    const target = systemDefinition.attributes.slots[targetSlotName];
    if (target) {
      product = getProductsBySlotNameAndId(targetSlotName, target.id, systemProducts);
    }
  }

  if (!product) {
    return null;
  }

  if ((product instanceof Array) || (Array.isArray && Array.isArray(product))) {
    product = product[0];
  }
  if (!product) {
    return null;
  }

  const {
    exhaust_layouts,
    diameters,
  } = product;
  const numExhaustLayouts = exhaust_layouts ? exhaust_layouts.length : 0;
  const numDiameters = diameters ? diameters.length : 0;
  if (!numExhaustLayouts || !numDiameters) {
    return null;
  }

  let diameter = findBestDiameter(diameters);
  const diameterConfigurations = diameter ? diameter.configurations : null;

  const exhaustLayout = findBestExhaustLayout(diameterConfigurations);

  if (diameter) {
    diameter = {
      main: diameter.main,
      diameter: diameter.diameter,
      adapter: null,
    };
  }

  diameter.adapter = findDiameterAdapterAccessoryId(slotName, systemDefinition, systemProducts, diameter);

  return {
    exhaust_layout: exhaustLayout,
    options: [],
    diameters: diameter,
  };
}

export function addProductToSystemDefinition(type, product, systemDefinition, systemProducts) { // eslint-disable-line
  const targetSlot = getTargetSlot(type, systemDefinition, systemProducts);
  let result = false;
  const targetProduct = systemDefinition.attributes.slots[targetSlot];
  if (!targetProduct.chimney) {
    let chimney = instantiateChimney(type, systemDefinition, systemProducts, product);
    if (!chimney) {
      chimney = false;
    }
    targetProduct.chimney = chimney;
    result = true;
  }

  return enableChimneyInSystemDefinition(true, systemDefinition) || result;
}

export function removeProductFromSystemDefinition(slotName, systemDefinition, systemProducts) { // eslint-disable-line
  const targetSlot = getTargetSlot(slotName, systemDefinition, systemProducts);
  const targetProduct = systemDefinition.attributes.slots[targetSlot];
  targetProduct.chimney = false;

  return enableChimneyInSystemDefinition(false, systemDefinition);
}

export function getAvailableNewProductsForSystemDefinition(systemDefinition) {
  if (!systemDefinition) {
    return null;
  }
  const { attributes } = systemDefinition;
  if (!attributes) {
    return null;
  }
  if (!attributes.has_chimney) {
    // Return pseudo element
    return [
      {
        id: 1,
        set_name: 'chimney.1',
      },
    ];
  }
  return null;
}

// Reset chimney properties on kettle (called when removing the chimney)
export function resetObjectAtSystemDefinitionSlot(slotName, systemDefinition, systemProducts) {
  const targetSlotName = getTargetSlot(slotName, systemDefinition, systemProducts);
  const kettleObject = getObjectAtSystemDefinitionSlot(targetSlotName, systemDefinition, systemProducts);
  if (!kettleObject) {
    return;
  }
  let kettleProduct = getProductsBySlotNameAndId(targetSlotName, kettleObject.id, systemProducts);
  if (Array.isArray(kettleProduct)) {
    kettleProduct = kettleProduct[0];
  }
  if (!kettleProduct) {
    return;
  }

  const { exhaust_layouts } = kettleProduct;
  const numExhaustLayouts = exhaust_layouts ? exhaust_layouts.length : 0;
  let defProperty = null;

  // Select C33 as default, or the first best choice if C33 isn't available
  for (let i = 0; i < numExhaustLayouts; i += 1) {
    const prop = exhaust_layouts[i];
    const propUC = prop && prop.toUpperCase ? prop.toUpperCase() : prop;
    if (!defProperty || propUC === 'C33') {
      defProperty = prop;
    }
  }
  kettleObject.property = defProperty;

  const chimneyOptions = kettleProduct.chimneys;
  const numChimneyOptions = chimneyOptions ? chimneyOptions.length : 0;
  const { options } = kettleObject;
  const numOptions = options ? options.length : 0;

  // Add required accessories
  for (let j = 0; j < numChimneyOptions; j += 1) {
    const chimneyOption = chimneyOptions[j];
    if (chimneyOption) {
      const required = !!chimneyOption.required;
      const { configurations } = chimneyOption;
      if (required && configurations && configurations.length > 0) {
        if (configurations.indexOf(defProperty, 0) >= 0) {
          let hasOption = false;
          for (let i = 0; !hasOption && i < numOptions; i += 1) {
            const option = options[i];
            if (option && option.set === 'chimney' && option.id === chimneyOption.id) {
              hasOption = true;
            }
          }
          if (!hasOption) {
            options.push(instantiateAccessory(chimneyOption, slotName, systemDefinition, systemProducts));
          }
        }
      }
    }
  }

  // Remove other accessories
  for (let i = numOptions - 1; i >= 0; i -= 1) {
    const opt = options[i];
    if (opt && opt.set === 'chimney') {
      const optId = opt.id;
      for (let j = 0; j < numChimneyOptions; j += 1) {
        const chimneyOption = chimneyOptions[j];
        const chimneyOptionId = chimneyOption ? chimneyOption.id : null;
        const required = chimneyOption ? !!chimneyOption.required : null;

        if (chimneyOptionId === optId && !required) {
          options.splice(i, 1);
          break;
        }
      }
    }
  }
}

export function getProductBrandName(
  slotName,
  systemDefinition,
  systemProducts,
  productData,
  intl, // eslint-disable-line
) {
  return null;
}

export function getProductDescription(
  slotName,
  systemDefinition,
  systemProducts,
  productData,
  intl, // eslint-disable-line
) {
  return null;
}

export function hasProductDescription(
  slotName,
  systemDefinition,
  systemProducts,
  productData, // eslint-disable-line
) {
  return false;
}

// Utils only for chimneys

function findAccessoryInfoInArray(accessory, array) {
  if (accessory === null) {
    return null;
  }
  const num = array ? array.length : 0;
  if (!num) {
    return null;
  }
  const type = typeof (accessory);
  if (type === 'undefined') {
    return null;
  }
  let accessoryId;
  if (type === 'string' || type === 'number') {
    accessoryId = accessory;
  } else if (type === 'object') {
    accessoryId = accessory.id;
  }

  if (accessoryId === null || typeof (accessoryId) === 'undefined') {
    return null;
  }
  accessoryId = `${accessoryId}`;

  for (let i = 0; i < num; i += 1) {
    const productAccessory = array[i];
    const productAccessoryId = productAccessory ? `${productAccessory.id}` : null;
    if (productAccessoryId === accessoryId) {
      return productAccessory;
    }
  }
  return null;
}

export function findAccessoryInfo(
  accessory,
  slotName,
  systemDefinition,
  systemProducts,
  regularAccessories = true,
  optionalAccessories = true,
) {
  // const productInfo = getProductInfoBySlotName(slotName, systemDefinition, systemProducts);

  let accessories = null;
  let res = null;

  if (regularAccessories) {
    accessories = getSystemObjectAccessories(slotName, systemDefinition, systemProducts, null, false);
    res = findAccessoryInfoInArray(accessory, accessories);
    if (res) {
      return { accessory: res, type: 'default' };
    }
  }
  if (optionalAccessories) {
    accessories = getSystemObjectAccessories(slotName, systemDefinition, systemProducts, null, true);
    res = findAccessoryInfoInArray(accessory, accessories);
    if (res) {
      return { accessory: res, type: 'optional' };
    }
  }

  return null;
}



// WEBPACK FOOTER //
// ./js/utils/project-definition/component/chimney/index.js